import { rateHandler } from './rate-handler';
import WebAPI from "./api-calls";

export const updateDirectDebit = (customerAccountNumber, bankAccountNumber, bankSortCode, bankAccountHolder, billingEmail) => {
    const task = async (res, rej) => {
        let webApi = new WebAPI();
        await webApi.postToWebApiWithAccessTokenAsync('/api/multiutility/direct-debit', JSON.stringify({ customerAccountNumber, bankAccountNumber, bankSortCode, bankAccountHolder, billingEmail }))
            .then(resp => {
                res(resp);
            })
            .catch(err => {
                console.log('error response', err)
                if (err && err.response && err.response.status === 429) return rej(err);
                res({ success: true });
            })
    }
    return rateHandler(task);
}

export const validateDirectDebit = (accountNumber, sortCode) => {
    const task = async (res, rej) => {
        let webApi = new WebAPI();
        await webApi.getFromWebApiWithAccessTokenAsync('/api/multiutility/direct-debit', { sortCode, accountNumber })
            .then(resp => {
                res(resp);
            })
            .catch(err => {
                console.log('error response', err)
                if (err && err.response && err.response.status === 429) return rej(err);
                res({ success: true });
            })
    }
    return rateHandler(task);
}
